// TODAS AS CONSTANTES RELACIONADAS A DEFAULT PARAMS - apenas troque os valores baseado na techspec
export enum AnalyticsConstantsDefaultParams {
  business = 'asset-management',
  environment = 'logado',
  business_channel = 'asset-transacional',
}
